module.exports = __webpack_public_path__ + "static/media/meditation19.94948618.mp3";